import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'computedAttributes',
  initialState: { items: [] },
  reducers: {
    setItems(state, action) { state.items = action.payload; },
  }
});

export { actions as computedAttributesActions };
export { reducer as computedAttributesReducer };
